import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as appDataActions from '../../../actions/appDataActions';
import Resources from '../resourceLinks/ResourceLinks';
import KpiResultReview from '../kpi/KpiResultReview';
import BadgeCollect from '../badges/BadgeCollect';
import * as trackingDataActions from "../../../actions/trackingDataActions";
import * as userDataActions from "../../../actions/userDataActions";
import * as appHelper from "../../../helpers/appHelper";
import * as objectConstants from "../../../constants/objectConstants";
import * as kpiConstants from "../../../constants/kpiConstants";
import {TweenLite, Elastic, Bounce, Expo, Linear} from "gsap";//eslint-disable-line import/no-named-as-default


class ShortResponseFeedbackReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            userData: this.props.userData,
            screenObject: this.props.screenObject,
            responseData: this.props.responseData,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgression: false,
            enableProgression: this.props.screenObject.kpis === null,
            optionFeedback: [],
            kpiDashboardParams: {
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false
            },
            hasBadges: appHelper.isDefined(this.props.screenObject.badges) && this.props.screenObject.badges.length > 0,
            badgesCollected: false,
            resourceLinks: [],
            hasResources: false,
            resourcesAreComplete: true,
            optionAsset: {
                src: ""
            },
            assetData: {},
            score_kpi: appHelper.isDefined(appHelper.getBite(this.props.responseData.bite_id).score_kpi) ? appHelper.getBite(this.props.responseData.bite_id).score_kpi : {},
            kpi_user_rating: {
                kpi_id: appHelper.isDefined(appHelper.getBite(this.props.responseData.bite_id).score_kpi) ? appHelper.getBite(this.props.responseData.bite_id).score_kpi.kpi_id :  null,
                value: null
            },
            ratingComplete: !this.props.selfRate

        };
        this.show = this.show.bind(this);
        this.onFeedbackRevealed = this.onFeedbackRevealed.bind(this);
        this.onFeedbackHidden = this.onFeedbackHidden.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.storeUserResponse = this.storeUserResponse.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.onRatingSelected = this.onRatingSelected.bind(this);
    }

    componentDidMount() {
        //this.handleOptionFeedback();

        this.setResources();
        this.show();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject)
            });
        }
    }

    storeUserResponse() {
        let selectedOptions = [this.state.screenObject.asset_id];
        let responseObj = {
            asset_id: this.state.screenObject.asset_id,
            selectedOptions: selectedOptions,
            kpis: this.state.screenObject.kpis !== null ? this.state.screenObject.kpis : []
        };
        this.props.callbacks.storeUserResponse(responseObj);
    }


    enableProgression() {
        this.setState({enableProgression: true});
    }

    onFeedbackRevealed() {
        //this.storeUserResponse();

    }

    onFeedbackHidden() {
        if (typeof this.props.onComplete !== 'undefined') {
            this.props.onComplete();
        }
    }


    onProgressionClicked() {
        //if(this.props.selfRate){
        let params = {
            userData: this.state.userData,
            bite_id: this.state.responseData.bite_id,
            screen_id: this.state.responseData.screen_id,
            parent_screen_id: appHelper.isDefined(this.props.callbacks.getSubScreenParent()) ? this.props.callbacks.getSubScreenParent().screen_id : undefined,
            asset_id: this.state.screenObject.asset_id,
            kpis: this.props.saveRating ? [this.state.kpi_user_rating] : []
        };

        this.props.actions.storeUserResponse(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((suspendData) => {

                this.hide();
            }).catch(error => {
            });
        }).catch(error => {
        });
        /*}else {
            this.hide();
        }*/
    }

    show() {
        let feedbackPanel = this.refs[`${this.state.screenObject.asset_id}_feedbackPanel`];
        TweenLite.set(feedbackPanel, {height: "auto", opacity: 1});
        TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
            height: 0,
            opacity: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onFeedbackRevealed);
        /**/
    }

    hide() {
        let feedbackPanel = this.refs[`${this.state.screenObject.asset_id}_feedbackPanel`];
        TweenLite.to(feedbackPanel, 1, {
            height: 0,
            opacity: 0,
            ease: Expo.easeInOut,
        }).eventCallback("onComplete", this.onFeedbackHidden);
    }


    onToolboxComplete(progression, asset_id, latestResponse) {
        this.setState({toolboxIsComplete: true});
    }

    setToolboxCallbacks() {
        this.setState(
            {
                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks,
                    {
                        onObjectComplete: this.onToolboxComplete,
                        isReviewMode: function () {
                            return false;
                        }
                    }
                )
            }
        );
    }

    onBadgeCollected() {
        this.setState({badgesCollected: true});
        //this.hide();
    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.screenObject);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0
        });

    }

    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    getDisabledState() {
        return !this.state.ratingComplete;
    }

    onRatingSelected(kpi) {

        this.setState({
            ratingComplete: true,
            kpi_user_rating: Object.assign({}, this.state.kpi_user_rating, {
                value: kpi.value
            })
        });
    }

    render() {
        return (
            <div className={`feedback-panel reflective`} ref={`${this.state.screenObject.asset_id}_feedbackPanel`}>

                <div className="feedback-content-col">
                    {appHelper.isDefined(this.state.locale.feedback) && this.state.locale.feedback.length > 0
                        ? <div dangerouslySetInnerHTML={{__html: this.state.locale.feedback}}/>
                        : null
                    }


                    {
                        this.state.hasResources
                            ?
                            <Resources resources={this.state.resourceLinks}
                                       onResourcesComplete={this.onResourcesComplete}/>
                            :
                            null
                    }

                    {this.state.responseData.kpis[0].value !== null
                        ?
                        <KpiResultReview kpiDefaults={this.state.score_kpi}
                                         kpi={{value: this.state.responseData.kpis[0].value}}/>
                        :null
                    }
                    {
                        this.state.hasBadges
                            ?
                            <div>
                                {this.state.screenObject.badges.map(badge =>
                                    <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id}
                                                  bite_id={this.state.responseData.bite_id}
                                                  asset_id={this.state.screenObject.asset_id}
                                                  onCollected={this.onBadgeCollected}/>
                                )}
                            </div>
                            : null
                    }
                </div>
            </div>
        );
    }
}


/*
*
*/
ShortResponseFeedbackReview.propTypes = {
    screenObject: PropTypes.object.isRequired,
    responseData: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    onComplete: PropTypes.func,
    scrollToFeedback: PropTypes.func,
    selfRate: PropTypes.bool,
    saveRating: PropTypes.bool,
    actions: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    showImages: PropTypes.bool,

};

ShortResponseFeedbackReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShortResponseFeedbackReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/shortResponse/ShortResponseFeedbackReview.js
 **/